import { render, staticRenderFns } from "./AbsenseSettings.vue?vue&type=template&id=a215da1c"
import script from "./AbsenseSettings.vue?vue&type=script&lang=js"
export * from "./AbsenseSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports